import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=77ffc336&scoped=true&lang=pug"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffc336",
  null
  
)

export default component.exports